export default __webpack_public_path__ + "cbff407388af85bc293c07bb9968d9f4.otf";